"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Share = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Share = function Share(props) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({
    transform: "rotate(0)"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M21.997 0.92258C21.9793 0.693041 21.8827 0.46845 21.7071 0.292893C21.4206 0.00643179 21.0036 -0.0699015 20.6476 0.0638934L0.669655 7.05617C0.282654 7.19162 0.0175501 7.54959 0.000836285 7.95926C-0.0158775 8.36894 0.219186 8.74731 0.593867 8.91384L9.2424 12.7576L13.0862 21.4062C13.2527 21.7808 13.6311 22.0159 14.0408 21.9992C14.4504 21.9825 14.8084 21.7174 14.9439 21.3304L21.9368 1.35057C21.9881 1.21326 22.0082 1.06694 21.997 0.92258ZM17.1943 3.39152L3.71108 8.11063L9.77852 10.8073L17.1943 3.39152ZM11.1927 12.2215L18.6086 4.80566L13.8894 18.289L11.1927 12.2215Z"
  }));
};

exports.Share = Share;